import { Button, Col, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { ReboqueInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { ButtonEditar, ButtonRemover, ButtonTrash, JTable, JTBody, JTHead, JvCaption } from "../../../components/Components";
import { removeTracaoReboque, removeTracaoReboqueTodos } from "../../../features/manifestoSlice";
import { useQuestion } from "../../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../../components/ModalMessage/useModalMessage";
import ReboqueForm from "./ReboqueForm";

const limite: number = 3;

const initialForm: ReboqueInterface = {
    id: 0,
    placa: '',
    tpCar: '00',
    uf: '',
    tara: 0,
    capKG: 0,
    capM3: 0,
    cint: '',
    renavam: '',
    prop: false,
    prop_cpfcnpj: '',
    prop_rntrc: '',
    prop_xNome: '',
    prop_ie: '',
    prop_uf: '',
    prop_tpProp: 0,
}
export default function Reboques() {
    const [form, setForm] = useState<ReboqueInterface>(initialForm);
    const listaReboques = useSelector((state: RootState) => state.manifesto.manifesto.modal_rodoviario.reboques);
    const { confirm, ConfirmModal } = useQuestion();
    const dispatch = useDispatch();
    const [saldo, setSaldo] = useState<number>(0);
    const [selecionado, setSelecionado] = useState<number | string>('');
    const [showForm, setShowForm] = useState<boolean>(false)
    const { alertModal, ModalMessageEl } = useModalMessage();
    

    const handleAdd = () => {
        if (listaReboques.length >= 3) {
            alertModal('Número máximo de reboques atingido!')

        } else {
            setForm(initialForm);
            setShowForm(true);
        }
    }

    const handleEdit = (id: number | string) => {
        setForm(listaReboques.find((item:ReboqueInterface) =>item.id === id))
        setShowForm(true);
        setSelecionado(id);
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        setSelecionado(value.id);
        const confirmed = await confirm({
            title: "Confirmação",
            message: <>Deseja realmente remover <strong>{value.title}</strong> ?</>
        })

        if (confirmed) {
            if (listaReboques.length > 0) {
                dispatch(removeTracaoReboque(value.id.toString()));
            }
        }
        setSelecionado('')
    }

    const removerTudo = async () => {
        if (listaReboques.length > 0) {
            const confirmed = await confirm({
                title: "Confirmação",
                message: <>Remover todos ?</>
            })
            if (confirmed) {
                dispatch(removeTracaoReboqueTodos());
            }
        }
    }

    const handleClose = () => {
        setShowForm(false);
        setSelecionado('');
    }

    useEffect(() => {
        setSaldo(listaReboques.length);
    }, [listaReboques])

    return (<>

        <Row className="mb-2">
            <Col md>
                <Button variant="primary" className="active" onClick={handleAdd} >
                    <FontAwesomeIcon icon={faPlus} /> Adicionar
                </Button>
            </Col>
        </Row>

        <Row>
            <Col md>

                <JTable>
                    <JvCaption>({saldo} de {limite} no máximo)</JvCaption>
                    <JTHead>
                        <tr>
                            <th className="text-center" style={{ width: '4.5rem' }}>
                                <ButtonTrash onClick={() => removerTudo()} icon={faTrashAlt} />
                            </th>
                            <th>Placa</th>
                            <th>Tara(kg)</th>
                            <th>Capacidade(kg)</th>
                            <th>Nome Proprietario</th>
                            <th>CPF/CNPJ</th>
                        </tr>
                    </JTHead>
                    <JTBody>
                        {listaReboques?.map((item: ReboqueInterface) => (
                            <tr key={item.id} className={item?.id?.toString() === selecionado.toString() ? 'table-danger' : ''}>
                                <td className="text-center d-flex justify-content-around">
                                    <ButtonRemover onClick={() => handleRemover({ id: item.id ?? '', title: item.placa })} />
                                    <ButtonEditar onClick={() => handleEdit(item.id ?? 0)} />
                                </td>
                                <td>{item.placa}</td>
                                <td>{item.tara}</td>
                                <td>{item.capKG}</td>
                                <td>{item.prop_xNome}</td>
                                <td>{item.prop_cpfcnpj}</td>
                            </tr>
                        ))}
                    </JTBody>
                </JTable>
            </Col>
        </Row>
        {ConfirmModal}
        {ModalMessageEl}
        <ReboqueForm
            show={showForm}
            handleClose={handleClose}
            form={form}
            setForm={setForm}
        />
    </>)
}